import React from 'react';
import { ProgressBar } from 'ehs-react';
import { usePortletStore } from '../../App';

function SensePortalComponent({
  progress
}: Readonly<{
  progress: number;
}>): React.JSX.Element {
  const portalName = usePortletStore(state => state.configuration.portalName);

  return (
    <section>
      <h1 className="portalname">{portalName}</h1>
      <ProgressBar hidePercentageValue percentage={progress} />
    </section>
  );
}

export const SensePortal = SensePortalComponent;
